import React from 'react'
import styles from './index.module.less'

export default function Index({ ...props }) {
  return (
    <div className={styles.weChat} {...props}>
      <div className={styles.icon}></div>
      <span>企业微信登录</span>
    </div>
  )
}
